import React, { Component } from 'react';
import Datas from '../data/pages/home.json';
import { Container, Row, Col } from 'react-bootstrap';
import Swiper from 'react-id-swiper';
import { Styles } from "./styles/heroImage.js";
import { getAssetUrl } from '../helper/assets';

class HeroImage extends Component {
    render() {
        const heroData = Datas.heroImage;
        const settings = {
            slidesPerView: 1,
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },
            watchSlidesVisibility: true,
            effect: 'fade',
            navigation: {
                nextEl: '.slider-button-next',
                prevEl: '.slider-button-prev'
            },
            renderPrevButton: () => (
                <div className="swiper-btn slider-button-prev"><i className="las la-angle-left"></i></div>
            ),
            renderNextButton: () => (
                <div className="swiper-btn slider-button-next"><i className="las la-angle-right"></i></div>
            )
        };

        const slides = heroData.slides;

        return (
            <Styles>
                {/* Hero Image */}
                <section className="hero-image-area">
                    <div className="hero-slider-wrapper">
                        <Swiper {...settings}>
                            {slides.map((slide, index) => (
                                <div key={index} className="slider-item" style={{ backgroundImage: `url(${getAssetUrl(slide.image)})` }}>
                                    <div className="hero-table">
                                        <div className="hero-tablecell">
                                            <Container>
                                                <Row>
                                                    <Col md="12">
                                                        <div className="hero-box text-center">
                                                            <h1>{slide.title}</h1>
                                                            <p>{slide.subtitle}</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Swiper>
                    </div>
                </section>
            </Styles>
        )
    }
}

export default HeroImage;
